import { EntityTypeEnum } from '@/types/enums/entity-type.enum';

export enum FavoritesAnalyticsEnum {
  FAVORITES_VIEW_PAGE = '[PAC WEB] Favoritos - Página visualizada',
  FAVORITES_ADD_PARTNER = '[PAC WEB] Favoritos - Favoritou parceiro',
  FAVORITES_REMOVE_PARTNER = '[PAC WEB] Favoritos - Desfavoritou parceiro',
  FAVORITES_CLICK_PARTNER = '[PAC WEB] Favoritos - Clicou em parceiro favorito',
}

export enum FavoritePartnerType {
  PROFISSIONAL = 'profissional',
  CLINICA = 'clinica',
  LABORATORIO = 'laboratorio',
}

export enum FavoriteOrigin {
  PERFIL = 'perfil',
  RESULTADO_BUSCA = 'resultado_busca',
  FAVORITOS = 'favoritos',
  HOME = 'home',
}

export const favoritePartnerTypeByEntity: Record<EntityTypeEnum, FavoritePartnerType> = {
  [EntityTypeEnum.PROFESSIONAL]: FavoritePartnerType.PROFISSIONAL,
  [EntityTypeEnum.CLINIC]: FavoritePartnerType.CLINICA,
  [EntityTypeEnum.BRANCH]: FavoritePartnerType.CLINICA,
  [EntityTypeEnum.LABORATORY_COLLECT_POINT]: FavoritePartnerType.LABORATORIO,
};
